export const CART_DROPDOWN_FIELDS = [
  "id",
  "email",
  "currency_code",
  "region_id",
  "metadata",
  "*items",
  "+items.metadata",
  "+items.total",
  "*items.variant",
  "*items.variant.product",
  "item_subtotal",
  "total",
].join(",")

export const CART_PAGE_FIELDS = [
  CART_DROPDOWN_FIELDS,
  "subtotal",
  "shipping_total",
  "discount_total",
  "gift_card_total",
  "gift_card_tax_total",
  "tax_total",
  "customer_id",
  "*promotions",
  // Expanded gift_cards currently returns 500 from the production Store Cart API.
  // Keep gift card totals, but don't ask Medusa to expand the relation here.
  "*credit_lines",
].join(",")

export const CHECKOUT_CART_FIELDS = [
  CART_PAGE_FIELDS,
  "*region",
  "*region.countries",
  "*shipping_address",
  "*billing_address",
  "*shipping_methods",
  "*payment_collection",
  "*payment_collection.payment_sessions",
].join(",")
